import TextareaAutosize from "react-textarea-autosize";
import styles from "./index.module.scss";

interface AutoResizingTextareaProps {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  placeholder?: string;
}

const AutoResizingTextarea: React.FC<AutoResizingTextareaProps> = ({
  value,
  onChange,
  placeholder,
}) => {
  return (
    <TextareaAutosize
      className={styles["textarea-autosize"]}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      minRows={1}
    />
  );
};

export default AutoResizingTextarea;
